import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import styles from './styles.module.css'
import { Table } from 'react-bootstrap'
import { setRatingValueActions } from '../../../../redux/reducers/BestSchool/bestSchoolReducer'
import cn from 'classnames'
import { Button } from "shards-react";
import { getExcelFromTable } from "../../../../utils/xlsx";
import { getPdfData } from "./pdf";
import { getSubData } from "../../../../utils/bestSchoolReport";
import classNames from "classnames";

const mapStateToProps = ({reports}) => ({
  data: reports.bestSchool.data,
  groups: reports.bestSchool.groups,
  criterions: reports.bestSchool.criterions,
  error: reports.bestSchool.error
});

const mapDispatchToProps = {
  setRatingValue: setRatingValueActions.setRatingValueRequestStart
};

const BestSchoolDataTable = ({ data, groups, criterions, setRatingValue, error }) => {

  const [schoolsList] = useState(Array.from(new Set(data.map(({orgname}) => orgname))))
  const [results, setResults] = useState(null)


  useEffect(() => {
    if (!criterions) return;
    const results = getSubData({data, criterions})
    setResults(results)
  }, [criterions, data])
  
  const getXlsx = () => {
    const table = document.getElementById('bestSchoolTable');
    getExcelFromTable(table, 'bestSchoolTable');
  }

  const toPdf = () => {
    getPdfData().then(doc => doc.save(`bestSchoolTable.pdf`))
  }

  const getUniqueResults = (list, criterionId) => {
    if (!list) return;
    const uniqueResults = Array.from(new Set(Object.values(list[criterionId])))
    const filteredResults = uniqueResults.filter(res => !!res)
    filteredResults.sort((a, b) => b - a)
    return filteredResults
  }

  const renderCriterion = (groupsLevel) => (criterion, ind) => {
    const { name, Groups, Options } = criterion
    const criterionName = groupsLevel ? `${ind+1}. ${name}` : name
    const hasChildren = Groups || Options || groupsLevel
    const rowValues = !hasChildren && data.filter(({indicator_id}) => indicator_id === criterion.id)
    const uniqueResults = groupsLevel && getUniqueResults(results, criterion.id)
    return (
      <>
        {hasChildren
          ? <tr>
              <td className={styles.stickyCell} style={{fontWeight: 'bold'}}>{criterionName}</td>
              <td colSpan={schoolsList.length}></td>
            </tr>
          : <tr>
              <td className={styles.stickyCell}>{criterionName}</td>
              {rowValues.map(value => <TableCell error={error} setRatingValue={setRatingValue} data={value}/>)}   
            </tr>
        }
        { Groups && Groups.map(renderCriterion())}
        { Options && Options.map(renderCriterion())}
        {groupsLevel && results && 
          <>
            <tr>
              <td className={classNames(styles.stickyCell, styles.resultCell)}>Сумма баллов по критерию</td>
              {schoolsList.map(school => <td className={styles.resultCell}>{results[criterion.id][school] || null}</td>)}
            </tr>
            <tr>
              <td className={classNames(styles.stickyCell, styles.resultCell)}>Место по критерию</td>
              {schoolsList.map(school => {
                const index = uniqueResults.indexOf(results[criterion.id][school])
                const place = index >= 0 ? index + 1 : ''
                return <td className={styles.resultCell}>{place}</td>
              })}
            </tr>
          </>
        }
      </>
    )
  }

  return (
    <>
      <div className={styles.buttonsBlock}>
        <Button
          theme="success"
          onClick={getXlsx}
        >
          Скачать .xlsx
        </Button>
        
        <Button
          theme="danger"
          className={styles.xlsxButton}
          onClick={toPdf}
        >
          Скачать pdf
        </Button>
      </div>
        <Table id='bestSchoolTable'>
          <thead>
            <tr>
              <th className={cn(styles.titleRow, styles.stickyCell)}>
                Критерий
              </th>
              {schoolsList.map(school =>
                <th className="">{school}</th>
              )}
            </tr>
          </thead>
          <tbody>
            {criterions && criterions.map(renderCriterion('groupsLevel'))}
          </tbody>
        </Table>
    </>
  );
};


const TableCell = ({data, setRatingValue, error}) => {
  
  const [value, setValue] = useState(data.raw_value == -1 ? '' : data.raw_value)
  
  useEffect(() => {
    if (!error) return;
    const { idOrganization, indicator_id, value } = data
    const { idOrg, indicator } = error
    if (idOrg === idOrganization && indicator === indicator_id) {
      setValue(value)
    }
  }, [error])
  

  const onCellBlur = (e) => {
    const { idOrganization, indicator_id } = data
    const newValue = e.target.innerText
    if (value == newValue) return; 
    const payload = {
      value: newValue,
      indicator: indicator_id,
      idOrg: idOrganization
    }
    setRatingValue(payload)
    setValue(newValue)
  }

  return (
    <td
      // contentEditable
      onBlur={onCellBlur}
      onKeyPress={(event) => !/[.0-9]/.test(event.key) && event.preventDefault()}
    >
      {value}
    </td>
  )
}







export default connect( mapStateToProps, mapDispatchToProps )(BestSchoolDataTable);
